'use strict';

export function UserResource($resource) {
  'ngInject';

  return $resource('/api/users/:id/:controller', {
    id: '@_id'
  }, {
    changePassword: {
      method: 'PUT',
      params: {
        controller: 'password'
      }
    },
    updateImage: {
      method: 'PUT',
      params: {
        controller: 'image'
      }
    },
    updateProfile: {
      method: 'PUT',
      params: {
        controller: 'profile'
      }
    },
    hideIntro: {
      method: 'PUT',
      params: {
        controller: 'hideIntro'
      }
    },
    updateGroups: {
      method: 'PUT',
      params: {
        controller: 'groups'
      }
    },
    updateRole: {
      method: 'PUT',
      params: {
        controller: 'role'
      }
    },
    get: {
      method: 'GET',
      params: {
        id: 'me'
      }
    }
  });
}



// WEBPACK FOOTER //
// ./client/components/auth/user.service.js